<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch6"><a id="ch6aa"></a><a id="ch6a"></a><a id="page_21"></a><a href="#/Contents#rch6"><span class="underline">LET <i>ME</i> WRITE SIGN—I GOOD SPEAK ENGLISH</span></a></h3>
<p class="center1"><span><i>When signs in foreign countries are written in English, any combination of words is possible. Here are some real-life examples</i>.</span></p>
<p class="noindent"><span><b><i>A sign in China (instructing people to keep off the grass)</i>:</b> “I like your smile but unlike you put your shoes on my face”</span></p>
<p class="noindent1a"><span><i><b>Outside a restaurant in Istanbul:</b></i> “Sorry We’re Open”</span></p>
<p class="noindent1a"><span><i><b>Outside a Thai building:</b></i> “Welcome to visit elephant dung factory &amp; souvenir shop”</span></p>
<p class="noindent1a"><span><b><i>On the border between Paraguay and Argentina:</i></b> “The paths to our resort are only passable by asses. Therefore, you will certainly feel at home here”</span></p>
<p class="noindent1a"><span><b><i>At a Hong Kong train station:</i></b> “The toilets will be partially suspended for use”</span></p>
<p class="noindent1a"><span><b><i>Next to a staircase in Japan:</i></b> “Please be careful about a step in a head”</span></p>
<p class="noindent1a"><span><b><i>Outside a restaurant in the Philippines:</i></b> “Try Our Fresh Deli Sandwiches Made with Imported Europeans Meat and Cheese”</span></p>
<p class="noindent1a"><span><b><i>Outside a Singapore restroom:</i></b> “A nearby toilet should be used for the direction of hurry”</span></p>
<p class="noindent1a"><span><i><b>On a path in Hiroshima:</b></i> “10 Min. Walk (7 if run a little) to Ropeway Stn.”</span></p>
<p class="noindent1a"><span><i><b>Inside Afghanistan’s Kabul Museum:</b></i> “Please Do Not Use the Flashy Cameras During the Photography”</span></p>
<p class="noindent1a"><span><b><i>On a winding road in India:</i></b> “Be Soft on My Curves”</span></p>
<p class="noindent1a"><span><b><i>At a French ski resort:</i></b> “Skiers: Entrance Through the Bottom is Compulsory”</span></p>
<p class="noindent1a"><span><b><i>At a zoo in China:</i></b> “Please do not feel or scare the animals”</span></p>
<p class="noindent1a"><span><b><i>Outside a church in Costa Rica:</i></b> “Please no explanations inside the church”</span></p>
<p class="noindent1a"><span><b><i>On a vending machine in Tokyo:</i></b> “Because I Do Not Have A Tissue Always Ready in This Restroom, Please Buy Used One”</span></p>
<div class="box">
<p class="center7"><span><b>Cookie Monster has five fingers; all other <i>Sesame Street</i> Muppets have only four.</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter006.vue?1ec9cc62